import { render, staticRenderFns } from "./DetectionReportFilter.vue?vue&type=template&id=720814f6&scoped=true"
import script from "./DetectionReportFilter.vue?vue&type=script&lang=js"
export * from "./DetectionReportFilter.vue?vue&type=script&lang=js"
import style0 from "./DetectionReportFilter.vue?vue&type=style&index=0&id=720814f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720814f6",
  null
  
)

export default component.exports